import axios from 'axios'

const namespaced = true

const state = {
  configs: [],
  types: [
    { type: 'room', label: '部屋' },
    { type: 'stair', label: '階段' },
    { type: 'door', label: 'ドア･窓' },
    { type: 'equipment', label: '住宅設備' },
    { type: 'furniture', label: '家具' },
    { type: 'interior', label: 'インテリア' },
    { type: 'exterior', label: 'エクステリア' },
  ],
  // エディタに入ったらこのコンフィグでアイテムを追加
  grabbing_config: null,
  // ItemShadowで表示するアイテム
  shadow_config: null,
  // ItemShadowで表示するか否か
  shadow: false,
}

const getters = {
  configsByType: state => (type, floor) => {
    let configs = state.configs.filter(config => {
      return config.disabled == false && (!floor || config.floor[floor] == true)
    })
    return _.sortBy(configs.filter(config => config.type == type), ['order'])
  },
  configById: state => id => {
    return state.configs.find(config => config.id == id)
  },
  grabbingConfig: state => {
    return state.grabbing_config
  },
  itemShadowConfig: state => {
    return state.shadow_config
  },
}

const actions = {
  fetchRemoteConfings({ commit, state, rootGetters }) {
    let params = {}
    if (window.flashVars.member_id) {
      params.member_id = window.flashVars.member_id
    }
    return axios.request({
        url: '/apis/getItemConf',
        method: 'get',
        headers: { 'Accept-Language': 'ja,en-US;q=0.9,en;q=0.8' },
        params,
        responseType: 'json',
      })
      .then(response => {
        let promies = Object.keys(response.data).map(type => {
          return response.data[type].map(c => {
            let config = {
              id: parseInt(c.mst_item_conf_id),
              order: parseInt(c.order_no),
              type: c.item_type || type,
              label: _.compact([c.main_text, c.sub_text]).join("\n"),
              texture_url: c.item_type == 'room' ? `/simulator_assets/img/item_texture/${c.texture_class_name}.png` : null,
              svg_url: c.item_type != 'room' ? `/simulator_assets/img/item_svg/${c.item_class_name}.svg` : null,
              img_url: c.item_type != 'room' ? `/simulator_assets/img/item_png/${c.item_class_name}${window.devicePixelRatio > 1 ? '_2x' : '' }.png` : null,
              disabled: c.enable != true,
              price: parseInt(c.price || 0),
              floor: {
                1: c.enable_low || false,
                2: c.enable_mid || false,
                3: c.enable_high || false,
              },
              catalog: {
                maker: c.catalog_maker || null,
                width: c.catalog_width || null,
                height: c.catalog_height || null,
                price: c.price || null,
                info: c.catalog_info || null,
                url: c.catalog_url || null,
              },
              room_count: c.enable_room_count || false,
              upper_floor_shadow: c.enable_upper_floor_shadow || false,
              floor_size_percent: parseInt(c.floor_size_percent),
              gaiheki_minus_size: parseInt(c.gaiheki_minus_size),
              naiheki_minus_size: parseInt(c.naiheki_minus_size),
              gaiheki_size_percent: parseInt(c.gaiheki_size_percent),
              naiheki_size_percent: parseInt(c.naiheki_size_percent),
              // 使用していない
              // droppable_inner: c.droppable_inner || false,
              // droppable_outer: c.droppable_outer || false,
              // floor1_gaisyu_length_percent: c.floor1_gaisyu_length_percent || null,
              // room_fixed_price: c.room_fixed_price || null,
              // yane_size_percent: c.yane_size_percent || null,
            }

            return Promise.resolve(config)
            // if (config.svg_url) {
            //   return axios.get(config.svg_url).then(response => {
            //     config.svg = response.data
            //     return config
            //   })
            // } else {
            //   return Promise.resolve(config)
            // }
          })
        })

        return Promise.all(_.flatten(promies)).then(configs => {
          commit('setConfigs', configs)
        })
      })
  },
  setGrabbingConfig({ commit }, config) {
    commit('setGrabbingConfig', config)
  },
  unsetGrabbingConfig({ commit }) {
    commit('unsetGrabbingConfig')
  },
  setItemShadowConfig({ commit }, config) {
    commit('setItemShadowConfig', config)
  },
  unsetItemShadowConfig({ commit }) {
    commit('unsetItemShadowConfig')
  },
  showItemShadow({ commit }) {
    commit('showItemShadow')
  },
  hideItemShadow({ commit }) {
    commit('hideItemShadow')
  },
}

const mutations = {
  setConfigs(state, configs) {
    state.configs = configs
  },
  setGrabbingConfig(state, config) {
    state.grabbing_config = config
    state.shadow_config = config
    state.shadow = true
  },
  unsetGrabbingConfig(state) {
    state.grabbing_config = null
    state.shadow_config = null
    state.shadow = false
  },
  setItemShadowConfig(state, config) {
    state.shadow_config = config
  },
  unsetItemShadowConfig(state) {
    state.shadow_config = null
  },
  showItemShadow(state) {
    state.shadow = true
  },
  hideItemShadow(state) {
    state.shadow = false
  },
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/item.js